var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row align-items-center text-center empty-graph"},[_c('div',{staticClass:"col"},[_c('img',{staticClass:"mb-3",staticStyle:{"max-height":"100px"},attrs:{"alt":_vm.$t('No results'),"src":"/img/graphics/statistic_chart.svg"}}),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.$t("No records available")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }